import { useCallback, useEffect, useState } from "react";

const PATTERN = /^#\/work\/([a-z0-9-]+)$/;
const read = () => PATTERN.exec(window.location.hash)?.[1] ?? null;

/**
 * Deep-linkable case files: `#/work/<slug>`.
 * - opening pushes a history entry, so the browser Back button closes the dialog
 * - closing pops that entry when we created it, otherwise replaces the URL,
 *   so no dead entries pile up in history
 * - a shared link opens the dialog on load
 */
export function useProjectRoute() {
  const [slug, setSlug] = useState(read);

  useEffect(() => {
    const sync = () => setSlug(read());
    window.addEventListener("popstate", sync);
    return () => window.removeEventListener("popstate", sync);
  }, []);

  const open = useCallback((next) => {
    window.history.pushState({ caseFile: true }, "", `#/work/${next}`);
    setSlug(next);
  }, []);

  const close = useCallback(() => {
    if (window.history.state?.caseFile) {
      window.history.back(); // popstate handler clears the slug
    } else {
      const { pathname, search } = window.location;
      window.history.replaceState(null, "", pathname + search);
      setSlug(null);
    }
  }, []);

  return { slug, open, close };
}
